import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsOption, { OptionType } from '../SettingsOption';

import { useFormikContext } from 'formik';
import { MdEditDocument } from 'react-icons/md';
import WaiverModal, { Waiver } from './WaiverModal';
import { cloneDeep } from 'lodash';

interface InitialWaiver {
  content: string;
  title: string;
  _id: string;
}

const WaiverSetting = ({ refetchEvent }: { refetchEvent: () => void }) => {
  const { t } = useTranslation(['events']);
  const { values } = useFormikContext<any>();

  const [showWaiverModal, setShowWaiverModal] = useState(false);

  const toggleWaiverModal = () => {
    setShowWaiverModal((showWaiverModal) => !showWaiverModal);
  };

  const waivers: Waiver[] = useMemo(
    () =>
      values?.waivers?.length > 0
        ? cloneDeep(
            values.waivers.map((waiver: InitialWaiver) => ({
              content: waiver.content,
              title: waiver.title,
              id: waiver._id
            }))
          )
        : [{ content: '', title: '', id: '' }],
    [values?.waivers]
  );

  return (
    <>
      <SettingsOption
        icon={<MdEditDocument size={20} />}
        title={t('events:settings.waiver.title')}
        actionLabel={t('events:settings.waiver.actionLabel')}
        value={
          values?.waivers?.length &&
          t('events:settings.waiver.totalCount', {
            count: values?.waivers?.length
          })
        }
        onClick={toggleWaiverModal}
        tooltipMessage={t('events:settings.waiver.tooltip')}
        type={OptionType.Button}
      />
      {showWaiverModal && (
        <WaiverModal
          refetchEvent={refetchEvent}
          eventId={values._id}
          onClose={toggleWaiverModal}
          initialValues={{
            waivers
          }}
        />
      )}
    </>
  );
};

export default WaiverSetting;
